export const SET_ACTIVE_TAB = 'set_active_tab';
export const GET_ACTIVE_TAB = 'get_active_tab';
export const REGISTER_TAB = 'register_tab';
export const OAP_TAB_COMPONENT_NAMESPACE = 'oap_tab_component';
